import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'

export const knowledgeBase = createQueryKeys('knowledgeBase', {
  recentlyViewed: null,
  allPaginated: (query?: any) => [query],
  popular: null,
  lastUpdated: (query?: any) => [query],
})

export type MarketingMaterialsKeys = inferQueryKeys<typeof knowledgeBase>
